import React from 'react';
import { Button, Div, Media, Text } from '@pezeshk-book/ui-kit';
import routes from '@routes';
import ArrowLeftIcon from '@icons-components/arrow-left-icon';

const Banner = () => {
  return (
    <Div className={'flex items-center gap-3 justify-center py-2 w-full z-[1000] bg-primary-50 h-8 md:h-12'}>
      <Media greaterThan={'sm'}>
        <Text typography={'sm'}>
          سفارش از داروخانه آنلاین
        </Text>
      </Media>
      <Button
        href={routes['route.pharmacies.index']}
        endAdornment={<ArrowLeftIcon/>}
        size={'tiny'}>
        <Media greaterThan={'sm'}>
          ثبت درخواست
        </Media>
        <Media lessThan={'md'}>
          سفارش از داروخانه آنلاین
        </Media>
      </Button>
    </Div>
  );
};

export default Banner;
